import {gsap} from 'gsap';

export default {
    init() {
        const w = {};

        w.width = $(window).width();

        const wb = {
            nav: {
                test() {
                    return true;
                },
                run() {
                    $('.nav-trigger').hover(
                        () => {
                            $('.nav-container').addClass('hover');
                            gsap.to('.menu-trigger__curve', 0.4, {
                                morphSVG: '.menu-trigger__line-02',
                                ease: Elastic.easeOut
                            });
                        },
                        () => {
                            $('.nav-container').removeClass('hover');

                            gsap.to('.menu-trigger__curve', 0.4, {
                                morphSVG: '.menu-trigger__curve',
                                ease: Bounce.easeOut
                            });
                        }
                    );

                    $('.site-header').on('click', '.nav-trigger', () => {
                        $('body').toggleClass('show-nav');
                        $('.nav-trigger').toggleClass('nav-trigger--opened');
                    });
                }
            },
            fadeInElements: {
                test() {
                    return $('[data-fade-delay]').length;
                },
                run() {
                    $('[data-fade-delay]').each((i, e) => {
                        const delay = parseInt($(e).attr('data-fade-delay'));
                        setTimeout(() => {
                            $(e).addClass('show');
                        }, delay);
                    });
                }
            },
            pageScroll: {
                test() {
                    return true;
                },
                run() {
                    let scrollTop = 0;
                    const scrollDistance = 100;
                    $(window).on('scroll', () => {
                        scrollTop = $(window).scrollTop();
                        if (scrollTop > scrollDistance) {
                            $('body').addClass('scrolled');
                        } else {
                            $('body').removeClass('scrolled');
                        }
                    });
                }
            },
            menuParallax: {
                test() {
                    return $('.menu-hero').length;
                },
                run() {
                    let scrollTop = 0;
                    $(window).on('scroll', () => {
                        scrollTop = $(window).scrollTop();
                        $('.menu-hero').css('top', scrollTop / 2);
                        $('.menu-hero__logo').css({
                            top: scrollTop / 5,
                            opacity: 1 - scrollTop / 500
                        });
                    });
                }
            },
            imagesWithBannerCarousel: {
                test() {
                    return $('.content-section--images-with-banner--images').length;
                },
                run() {
                    $('.content-section--images-with-banner--images').slick({
                        arrows: false,
                        autoplay: true,
                        autoplaySpeed: 3000,
                        dots: false,
                        fade: true,
                        infinite: true,
                        speed: 1000,
                        draggable: true
                    });
                }
            },
            pronunciationAudio: {
                test() {
                    return $('.content-section--pronunciation-block--audio').length;
                },
                run() {
                    const files = $('.content-section--pronunciation-block--audio').data('audio');
                    const fileArray = files.split(',');
                    let file;
                    let prevNum = 0;
                    $('body').on('click', '.speaker-icon', e => {
                        e.preventDefault();
                        let i = Math.round(Math.random() * (fileArray.length - 1));
                        // If we get the same number as last time, let's regenerate the random #
                        if (i == prevNum) {
                            i = Math.round(Math.random() * (fileArray.length - 1));
                        }
                        prevNum = i;
                        file = fileArray[i];
                        const audio = new Audio(file);
                        audio.play();
                    });
                }
            },
            findClosestLocation: {
                test() {
                    return $('.find-closest-store').length;
                },
                run() {
                    $('body').on('click', '.find-closest-store', function(e) {
                        e.preventDefault();

                        if (!navigator.geolocation) {
                            alert('Geolocation is not supported by this browser.');
                        } else {
                            $('.found-store-curtain').addClass('show');
                            navigator.geolocation.getCurrentPosition(getClosestStore);
                        }

                        const button = $(this);

                        function getClosestStore(userPosition) {
                            $.ajax({
                                url: '/wp-json/wp/v2/locations'
                            }).done(data => {
                                // Utility Functions

                                function haversineDistance(coords1, coords2, isMiles) {
                                    function toRad(x) {
                                        return (x * Math.PI) / 180;
                                    }

                                    const lon1 = coords1[0];
                                    const lat1 = coords1[1];

                                    const lon2 = coords2[0];
                                    const lat2 = coords2[1];

                                    const R = 6371; // km

                                    const x1 = lat2 - lat1;
                                    const dLat = toRad(x1);
                                    const x2 = lon2 - lon1;
                                    const dLon = toRad(x2);
                                    const a =
                                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                                        Math.cos(toRad(lat1)) *
                                            Math.cos(toRad(lat2)) *
                                            Math.sin(dLon / 2) *
                                            Math.sin(dLon / 2);
                                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                                    let d = R * c;

                                    if (isMiles) d /= 1.60934;

                                    return d;
                                }

                                const currentLocation = {
                                    lat: userPosition.coords.latitude,
                                    lng: userPosition.coords.longitude,
                                    accuracy: userPosition.coords.accuracy
                                };

                                let closestStoreIndex = 0;
                                let closestDistance = 10000;

                                for (let i = 0; i < data.length; i++) {
                                    // Ignore locations that don't have geolocation data stored
                                    if (data[i].acf.geolocation) {
                                        const distance = haversineDistance(
                                            [currentLocation.lng, currentLocation.lat],
                                            [data[i].acf.geolocation.lng, data[i].acf.geolocation.lat],
                                            true
                                        );
                                        if (distance < closestDistance) {
                                            closestDistance = distance;
                                            closestStoreIndex = i;
                                        }
                                    }
                                }
                                renderClosestLocation(data[closestStoreIndex]);
                                // window.location.href = data[closestStoreIndex].link;
                            });
                        }

                        function renderClosestLocation(closestLocationData) {
                            const source = document.getElementById('foundStoreTemplate').innerHTML;
                            const template = Handlebars.compile(source);
                            const context = closestLocationData;
                            const html = template(context);
                            $('.found-store-curtain').html(html);
                            setTimeout(() => {
                                $('.found-store-content').addClass('show');
                            }, 100);
                        }

                        $('body').on('click', '.found-store-curtain .close-btn', e => {
                            e.preventDefault();
                            $('.found-store-content').fadeOut(300);
                            setTimeout(() => {
                                $('.found-store-curtain').removeClass('show');
                            }, 500);
                        });
                    });
                }
            },
            cateringGustoTaps: {
                test: function() {
                    return $('.catering--options--gusto-item ').length;
                },
                run: function() {
                    $('.catering-options--gusto').on('touchend', '.catering--options--gusto-item', function(e) {
                        e.preventDefault();
                        $(this).toggleClass('show-details');
                    });
                }
            },
            stickySlides: {
                test: function() {
                    return $('.content-section--sticky-slides').length;
                },
                run: function() {
                    const instances = $('.content-section--sticky-slides');

                    instances.each(function(i, e) {
                        // Determine if the entire slide carousel is in the viewport as we scroll
                        e.handler = function() {
                            if (isCarouselInViewport(e)) {
                                $(e).addClass('in-viewport');
                            } else {
                                $(e).removeClass('in-viewport');
                            }
                        };

                        $(window).on('DOMContentLoaded load resize scroll', e.handler);

                        // Determine and handle if the individual slides are in the viewport as we scroll
                        var surrogates = $(e).find('.content-section--sticky-slides--slide-surrogate');
                        var slides = $(e).find('.content-section--sticky-slides--slide');

                        surrogates.each(function(i, e) {
                            e.handler = function() {
                                if (isSlideInViewport(e)) {
                                    slides.eq(i).addClass('active-slide');
                                } else {
                                    slides.eq(i).removeClass('active-slide');
                                }
                            };

                            $(window).on('DOMContentLoaded load resize scroll', e.handler);
                        });
                    });

                    function isCarouselInViewport(el) {
                        if (typeof jQuery === 'function' && el instanceof jQuery) {
                            el = el[0];
                        }

                        var rect = el.getBoundingClientRect();

                        return rect.top <= 0 && rect.bottom > $(window).height();
                    }

                    function isSlideInViewport(el) {
                        if (typeof jQuery === 'function' && el instanceof jQuery) {
                            el = el[0];
                        }

                        var rect = el.getBoundingClientRect();

                        return rect.top <= 0 && rect.top > $(window).height() * -1;
                    }
                }
            },
            homeParallax: {
                test: function() {
                    return $('.content-section--home-hero').length;
                },
                run: function() {
                    // parallax hero image
                    var scrollTop = 0;
                    var homeHeroImage = $('.content-section--home-hero--top--image').first();
                    var homeHeroContent = $('.content-section--home-hero--content').first();
                    function parallaxHeroImage() {
                        scrollTop = $(window).scrollTop();
                        homeHeroContent.css({ top: scrollTop / 3 });
                        homeHeroImage.css({ top: scrollTop / 5 });
                    }
                    $(window).on('scroll', parallaxHeroImage);
                }
            }
        };

        function runObject() {
            for (const key in wb) {
                if (wb[key].test()) {
                    wb[key].run();
                }
            }
        }

        runObject();
    },
    finalize() {
        // ::
        // MODAL OPEN ---------------------------::
        // ____
        $('[data-open-modal]').click(function(event) {
            event.preventDefault();

            const modal = $(this).attr('data-modal-contents');

            $(`[data-gusto-modal="${modal}"]`).addClass('gusto-modal--show');
        });

        // ::
        // CLOSE MODAL ---------------------------::
        // ____
        $('.gusto-modal__close').click(() => {
            $('.gusto-modal').removeClass('gusto-modal--show');
        });
    }
};
